/**
 * 默认粉丝群处理
 */
import { mapGetters } from 'vuex'
import { getDefaultTopLiveFansGroup } from './_service'

const LIVE_FANS_GROUP_CHANNEL = ['MMP-Menu', 'WechatOA-Menu']

const fetchLiveFansGroup = (channel, cb) => {
  const isLiveFansGroupChannel = () => {
    return LIVE_FANS_GROUP_CHANNEL.includes(channel)
  }

  if (!isLiveFansGroupChannel()) return

  getDefaultTopLiveFansGroup(channel).then(data => {
    cb && cb(data)
  })
}

export default {
  computed: {
    ...mapGetters('channel', ['channel', 'campaign'])
  },

  data() {
    return {
      liveFansGroup: null
    }
  },

  mounted() {
    fetchLiveFansGroup(this.channel, data => {
      this.liveFansGroup = data
    })
  }
}
